import { Grid, Typography } from '@mui/material';
import { NullRobot } from '@/icons';

interface BlankPanelProps {
  title?: string;
  dynamicText?: string;
  dataId?: string;
}

const BlankPanel = ({ title, dynamicText, dataId }: BlankPanelProps) => {
  return (
    <Grid
      item
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        flex: '1 0 0',
        alignSelf: 'stretch',
        background: '#FFF',
        minHeight: 'calc(100vh - 250px)',
        overflow: 'hidden',
        // minWidth: '467px',
        // padding: '0px 149px'
      }}
      data-testid={dataId}
      className='blank-panel'
    >
      <Grid item container direction={'column'} justifyContent={'center'} alignItems={'center'} sx={{ width: '361px' }}>
        <Grid item>
          <NullRobot />
        </Grid>
        <Grid item>
          <Typography
            sx={{
              color: 'var(--gray-600, #737373)',
              textAlign: 'center',
              fontSize: '16px',
              fontFamily: 'Poppins',
              fontWeight: 500,
              lineHeight: '24px',
              fontStyle: 'normal'
            }}
          >
            {dynamicText ? dynamicText : `Select a ${title} from table to see details`}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default BlankPanel;
